import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccesoComponent } from './acceso.component';
import { DxCheckBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { ValidationErrorMessagePipe } from 'src/app/_helpers/validacion-form.service';

@NgModule({
  declarations: [AccesoComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    ValidationErrorMessagePipe,
  ],
  exports: [AccesoComponent],
})
export class AccesoModule {}
